if (!customElements.get('product-data')) {
  customElements.define('product-data', class ProductData extends HTMLElement {
    constructor() {
      super();
  
      this.constSingleTitle = 'バラ';
      this.constSingleId = 'single';
      this.constQueenTitle = 'クイーン';
      this.constQueenId = 'queen';
      this.constKingTitle = 'キング';
      this.constKingId = 'king';
  
      this.productData = {};

      this.setBasicData();
      this.setLotData();
  
      this.productData['variant'] = {};
      this.setVariantData(this.constSingleId);
      this.setVariantData(this.constQueenId);
      this.setVariantData(this.constKingId);
    }

    setBasicData() {
      this.productData['id'] = this.querySelector(`.js-product-id`).textContent;
      this.productData['title'] = this.querySelector(`.js-product-title`).textContent;
      this.productData['handle'] = this.querySelector(`.js-product-handle`).textContent;
    }

    setLotData() {
      const elLotQueen = this.querySelector(`.js-lot-${this.constQueenId}`);
      const lotQueen = elLotQueen? parseInt(elLotQueen.textContent, 10) : null;
      const elLotKing = this.querySelector(`.js-lot-${this.constKingId}`);
      const lotKing = elLotKing? parseInt(elLotKing.textContent, 10) : null;
  
      this.productData['lot'] = {
        [this.constQueenId]: lotQueen,
        [this.constKingId]: lotKing,
      }
    }
  
    setVariantData(variantKey) {
      const elVariantList = this.querySelectorAll(`.js-variant[data-package-type="${variantKey}"]`);
  
      if (elVariantList.length > 0) {
        this.mapVariantData(variantKey, elVariantList)
      };
    }
  
    mapVariantData(variantKey, variantList) {
      this.productData['variant'][variantKey] = [];
  
      for (let i = 0; i < variantList.length; i++) {
        const targetVariant = variantList[i];
        const variantTitle = targetVariant.querySelector('.js-variant-title').textContent;
  
        let titleItems = variantTitle? variantTitle.split('/') : [];
        titleItems = titleItems.filter((item) => !(
          item.includes(this.constSingleTitle) ||       
          item.includes(this.constQueenTitle) ||
          item.includes(this.constKingTitle))
        );
        titleItems = titleItems.map((item) => item.trim());
  
        let priceStr = targetVariant.querySelector('.js-variant-price').textContent;
        priceStr = priceStr.replace(/,/g, '');
  
        // const inventoryQuantity = targetVariant.querySelector('.js-variant-inventory-quantity').textContent;

        let isAvailable = true;
        const elVariantAvailable = targetVariant.querySelector('.js-variant-available');
        if (elVariantAvailable.textContent === 'false') {
          isAvailable = false;
        }
  
        const elVariantComparePrice = targetVariant.querySelector('.js-variant-compare-price');
        let comparePriceStr = elVariantComparePrice? elVariantComparePrice.textContent : '';
        comparePriceStr = comparePriceStr.replace(/,/g, '');

        const elVariantInformation = targetVariant.querySelector('.js-variant-information');
        let information = elVariantInformation? elVariantInformation.textContent : '';
  
        const data = {
          id: targetVariant.querySelector('.js-variant-id').textContent,
          title: titleItems.join(' / '),
          price: parseInt(priceStr, 10),
          comparePrice: comparePriceStr ? parseInt(comparePriceStr, 10) : null,
          isAvailable: isAvailable,
          information: information
        }
  
        this.productData['variant'][variantKey].push(data);
      }
    }
  
    getProductData () {
      return this.productData;
    }
  
  })
}